import { interval } from 'rxjs';
import { filter, switchMap, take } from 'rxjs/operators';

import { httpDelete, httpGet, httpPut } from '@pressreader/services';

import { ICreditCardDto, ICreditCardUpdateResponseDto } from './types';

const serviceBasePath = 'v1/accounts';

function getCreditCard(): Promise<ICreditCardDto> {
    return httpGet<ICreditCardDto>(serviceBasePath, 'current/creditcard');
}

function updateCreditCard(creditCard: ICreditCardDto): Promise<ICreditCardUpdateResponseDto> {
    return httpPut<ICreditCardUpdateResponseDto>(serviceBasePath, 'current/creditcard', JSON.stringify(creditCard), {
        contentType: 'application/json',
        disableRetry: true,
    });
}

function checkCreditCardUpdate(updateId: string): Promise<ICreditCardUpdateResponseDto> {
    return httpGet<ICreditCardUpdateResponseDto>(serviceBasePath, `current/creditcard/updates/${updateId}`);
}

function awaitPendingCreditCardUpdate(updateId: string): Promise<ICreditCardUpdateResponseDto> {
    return new Promise(resolve => {
        // start polling
        const pollingIntervalMilliseconds = 1000;
        interval(pollingIntervalMilliseconds)
            .pipe(
                switchMap(() => checkCreditCardUpdate(updateId)),
                filter(({ status }) => status !== 'Pending'),
                take(1),
            )
            .subscribe(resolve);
    });
}

function deleteCreditCard(): Promise<void> {
    return httpDelete(serviceBasePath, 'current/creditcard', null, { disableRetry: true });
}

export { getCreditCard, updateCreditCard, awaitPendingCreditCardUpdate, deleteCreditCard };
